<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 20 20">
    <path
      d="M9.24622 3C12.6957 3.00023 15.4922 5.7967 15.4923 9.24609L15.4845 9.56738C15.4171 10.8973 14.9321 12.1167 14.1603 13.0996L16.7804 15.7197C17.0732 16.0126 17.0732 16.4874 16.7804 16.7803C16.4875 17.0731 16.0128 17.0731 15.7198 16.7803L13.0997 14.1602C12.0381 14.9938 10.7007 15.4921 9.24622 15.4922L8.92493 15.4844C5.73102 15.3225 3.16979 12.7612 3.00793 9.56738L3.00012 9.24609C3.00019 5.79662 5.79662 3.0001 9.24622 3ZM9.24622 4.5C6.62499 4.5001 4.50019 6.6251 4.50012 9.24609C4.50015 11.8671 6.62497 13.9921 9.24622 13.9922C11.8674 13.992 13.9923 11.867 13.9923 9.24609C13.9922 6.62518 11.8673 4.50023 9.24622 4.5Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconSearch',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
